import ApiUser from 'types/api/User';
import { ApiResources } from 'types/apiResources';
import { Endpoints } from 'types/endpoints';

import User from 'models/User';

import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ResetPasswordParams {
    email: string;
}
export const resetPassword = async (params: ResetPasswordParams): Promise<any> => {
    const response = await request({
        method: 'DELETE',
        path: withVariables(Endpoints.PublicUsersPassword, params),
        requestParams: params,
    });

    return response;
};

export interface SetPasswordParams {
    token: string;
    password: string;
    passwordConfirm: string;
}
export const setPassword = async (params: SetPasswordParams): Promise<User> => {
    const response = await request({
        method: 'POST',
        path: withVariables(Endpoints.PublicUsersPassword, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource: ApiUser = data && data[ApiResources.Me];

    if(!data || !resource) {
        return null;
    }

    return resource;
};
